import { useQuery } from '@tanstack/react-query';

import { chatSettingsQueryOptions } from './chat-settings-query';

export function useChatSettings(storeId: string) {
  return useQuery(chatSettingsQueryOptions(storeId));
}
